module.exports = __webpack_public_path__ + "0cc66f18113d05a5e7007c4c60aac929.png";